/** 어드민 편집 표의 입력 클래스 — PricingPanel 과 PresetTable 이 같은 모양을 쓰도록 한곳에 둬요. */
export const inputClass =
  "wds-body-2 w-full rounded-md border border-line-neutral bg-background-normal px-3 py-2 text-label-normal";
export const numberInputClass = `${inputClass} text-right tabular-nums`;
export const iconButtonClass =
  "inline-flex h-8 w-8 items-center justify-center rounded-md bg-background-alternative text-label-neutral disabled:opacity-30";
